/**
 * Hook that fetches and auto-refreshes dynamic wait time from the backend.
 * Polls every 60 seconds.
 */

import { menuWidgetApi } from '@/store/convenienceAccessor'
import { getEnvironmentConfig } from '@/config/environment'

export interface WaitTimeData {
  estimated_wait_minutes: number
  active_orders: number
  prep_time_minutes: number
  capacity_enabled: boolean
}

export function useWaitTime() {
  const config = getEnvironmentConfig()

  const { data, isLoading, error } = menuWidgetApi.waitTime.get(
    { restaurant_id: config.restaurantId },
    { pollingInterval: 60_000 },
  )

  return {
    waitTime: data as WaitTimeData | undefined,
    isLoading,
    error,
  }
}
